import NavBar from "../navbar";
import Footer from "../footer";

import SyncBanner from "../../assets/sync-playlists.png"
import SyncRunBanner from "../../assets/sync-run-banner.png"

import config from "../../config";

import { Helmet } from "react-helmet";


function ViewSyncRun() {

    const features = [
        {
            name: 'Sync runs: ',
            description: 'Open Sync to see the sync runs and metrics of sync runs.',
        },
        {
            name: 'Manage sync activities: ',
            description: 'Open Sync to view the sync activites and change the songs added/removed.',
        },
    ]


    return (

        <>

            <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6">

                {/* Row */}
                <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
                    <div className="text-gray-500 sm:text-lg dark:text-gray-400">

                        <div className="lg:row-start-2 lg:max-w-md">
                            <h2 className="text-3xl font-semibold tracking-tight text-balance text-gray-900 dark:text-white sm:text-4xl">
                                Manage Sync activities
                            </h2>
                            <p className="mt-6 text-lg/8 text-gray-500 sm:text-xl dark:text-gray-400">
                                View your sync runs and edit the sync activites
                            </p>
                            
                        </div>
                        
                        <div className="pt-4 max-w-xl lg:row-start-3 lg:mt-10 lg:max-w-md lg:border-t lg:border-white/10 lg:pt-10">
                            <dl className="max-w-xl space-y-8 text-base/7 text-gray-300 lg:max-w-none">

                            {features.map((feature) => (
                            <div key={feature.name} className="">
                                <dt className="inline-block font-semibold text-gray-900 dark:text-white">
                                    <span>{feature.name}</span>
                                </dt>{' '}
                            <dd className="inline text-gray-500 dark:text-gray-400">{feature.description}</dd>
                            </div>
                            ))}

                            </dl>
                        </div>

                    </div>
                    <img
                        className="pt-4 w-full mb-4 rounded-lg lg:mb-0 lg:flex"
                        src={SyncRunBanner}
                        alt="Transfer Playlists, albums and favourite songs"
                    />
                </div>
            </div>




        </>
    )
}



function SyncFeature() {

    const features = [
        {
            name: 'Transfer your playlist: ',
            description: 'Transfer the playlist you want to keep in sync first.',
        },
        {
            name: 'Create Sync: ',
            description: 'Once transfer completes, click "Create Sync" from the transfer history.',
        }
    ]


    return (

        <>

            <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6">

                {/* Row */}
                <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
                    <div className="text-gray-500 sm:text-lg dark:text-gray-400">

                        <div className="lg:row-start-2 lg:max-w-md">
                            <h2 className="text-3xl font-semibold tracking-tight text-balance text-gray-900 dark:text-white sm:text-4xl">
                                Sync playlists across platforms
                            </h2>
                            <p className="mt-6 text-lg/8 text-gray-500 sm:text-xl dark:text-gray-400">
                                
                            </p>
                        
                        </div>
                        
                        <div className="pt-4 max-w-xl lg:row-start-3 lg:mt-10 lg:max-w-md lg:border-t lg:border-white/10 lg:pt-10">
                            <dl className="max-w-xl space-y-8 text-base/7 text-gray-300 lg:max-w-none">

                            {features.map((feature) => (
                            <div key={feature.name} className="">
                                <dt className="inline-block font-semibold text-gray-900 dark:text-white">
                                    <span>{feature.name}</span>
                                </dt>{' '}
                            <dd className="inline text-gray-500 dark:text-gray-400">{feature.description}</dd>
                            </div>
                            ))}

                            </dl>
                        </div>


                    </div>
                    <img
                        className="pt-4 w-full mb-4 rounded-lg lg:mb-0 lg:flex"
                        src={SyncBanner}
                        alt="Transfer Playlists, albums and favourite songs"
                    />
                </div>
            </div>

        </>
    )
}



export default function Sync() {



    return (

        <>

            {/* {Navbar} */}
            <NavBar selected={"sync"}></NavBar>


            <>
                {/* Start block */}
                <section className="bg-white dark:bg-zinc-950">
                    <div className="max-w-screen-xl pt-20 px-4 py-8 mx-auto lg:py-24 lg:px-6 lg:pt-28">
                        <div className="max-w-screen-md mx-auto mb-8 text-center lg:mb-12">
                            <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                                Sync your playlists across music platforms
                            </h2>
                            <p className="mb-5 font-light text-gray-500 sm:text-xl dark:text-gray-400">
                            With our smart sync feature, keep your playlists updated across all platforms automatically—no need to transfer again when you add or remove tracks.
                            </p>
                        </div>
                    </div>
                </section>
                {/* End block */}
            </>




            { }

            <section className="bg-white dark:bg-zinc-800">
                <SyncFeature></SyncFeature>
            </section>


            <section className="bg-gray-50 dark:bg-zinc-950">
                <ViewSyncRun></ViewSyncRun>
            </section>

            { }




            {/* Start block */}
            <section className="bg-gray-50 dark:bg-zinc-800">
                <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6">
                    <div className="max-w-screen-sm mx-auto text-center">
                        <h2 className="mb-4 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">
                            Start your transfer for free
                        </h2>
                        <p className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">

                        </p>
                        <a
                            href={config.signupPath}
                            className="text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 focus:outline-none dark:focus:ring-purple-800"
                        >
                            Sign up
                        </a>
                    </div>
                </div>
            </section>

            <Footer></Footer>
        </>
    )
}